import { escapeHtml } from "@emkit/builder-core";
export const CHART_DEFAULTS = {
    kind: "bar-vertical",
    points: [
        { id: "c1", label: "Jan", value: 32 },
        { id: "c2", label: "Feb", value: 48 },
        { id: "c3", label: "Mar", value: 57 },
        { id: "c4", label: "Apr", value: 72 },
        { id: "c5", label: "May", value: 64 },
        { id: "c6", label: "Jun", value: 88 },
    ],
    accent: "#111827",
    background: "transparent",
    gridColor: "#e5e7eb",
    labelColor: "#6b7280",
    showValues: true,
    height: 260,
};
export const chartWidget = {
    type: "chart",
    defaultProps: CHART_DEFAULTS,
    renderHtml(props) {
        const points = props.points ?? [];
        if (points.length === 0) {
            return `<div class="emk-chart" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(No data points)</div>`;
        }
        const kind = props.kind ?? "bar-vertical";
        const accent = props.accent ?? "#111827";
        const bg = props.background ?? "transparent";
        const grid = props.gridColor ?? "#e5e7eb";
        const labelColor = props.labelColor ?? "#6b7280";
        const showValues = props.showValues ?? true;
        const height = props.height ?? 260;
        const max = Math.max(...points.map((p) => p.value), 1);
        if (kind === "bar-horizontal") {
            const rows = points
                .map((p) => {
                const pct = (p.value / max) * 100;
                const color = p.color ?? accent;
                return `<div style="display:grid;grid-template-columns:100px 1fr auto;align-items:center;gap:12px"><span style="font-size:13px;color:${labelColor};overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${escapeHtml(p.label)}</span><div style="height:14px;background:${grid};border-radius:7px;position:relative;overflow:hidden"><div style="position:absolute;inset:0;width:${pct}%;background:${color};border-radius:7px"></div></div>${showValues ? `<span style="font-size:13px;font-variant-numeric:tabular-nums;color:${labelColor};min-width:40px;text-align:right">${p.value}</span>` : ""}</div>`;
            })
                .join("");
            return `<div class="emk-chart" style="background:${bg};padding:16px;border-radius:8px;font-family:inherit;display:flex;flex-direction:column;gap:10px">${rows}</div>`;
        }
        // Vertical bars via flex + aspect-based heights. Pure CSS, no SVG.
        const bars = points
            .map((p) => {
            const pct = (p.value / max) * 100;
            const color = p.color ?? accent;
            const valueLabel = showValues
                ? `<span style="position:absolute;top:-20px;left:50%;transform:translateX(-50%);font-size:11px;color:${labelColor};font-variant-numeric:tabular-nums">${p.value}</span>`
                : "";
            return `<div style="flex:1;min-width:0;display:flex;flex-direction:column;align-items:center;gap:8px"><div style="position:relative;width:100%;height:${height - 48}px;display:flex;align-items:flex-end"><div style="width:100%;height:${pct}%;background:${color};border-radius:6px 6px 0 0;position:relative">${valueLabel}</div></div><span style="font-size:12px;color:${labelColor};text-align:center;overflow:hidden;text-overflow:ellipsis;max-width:100%;white-space:nowrap">${escapeHtml(p.label)}</span></div>`;
        })
            .join("");
        return `<div class="emk-chart" style="background:${bg};padding:28px 16px 16px;border-radius:8px;font-family:inherit"><div style="display:flex;align-items:flex-end;gap:8px;height:${height}px;border-bottom:1px solid ${grid}">${bars}</div></div>`;
    },
};
//# sourceMappingURL=chart.js.map